export class SummaryLineData{
    constructor(date?: string, idsCount?: number, skusCount?: number, wrhsCount?: number){
        if (date){
            this.date = date;
            this.idsCount = idsCount;
            this.skusCount = skusCount;
            this.wrhsCount = wrhsCount;
        }

    }

    public date: string;
    public idsCount: number;
    public skusCount: number;
    public wrhsCount: number;

}

export class SummaryLineDataName{
    constructor(public lineName: string, public data: SummaryLineData[]){
    }
}

export enum SummaryChartLineTooltip{
    All = 0,
    WrhSKU = 1,
    Items = 2
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/summary-line-data.ts